// extracted by mini-css-extract-plugin
export var fistGlow = "styles-module--fist-glow--c6b77";
export var secondGlow = "styles-module--secondGlow--8276d";
export var subtitle = "styles-module--subtitle--e9ccb";
export var title = "styles-module--title--6c35c";
export var wrapper = "styles-module--wrapper--59cd8";